import { Controller } from '../utils/controller';
import { useIntersection } from 'stimulus-use';

export default class extends Controller {
  connect() {
    useIntersection(this);
  }

  static targets = ['stickyFooter', 'stickyFooterMobile'];
  static requiredTargets = [];
  declare stickyFooterTarget: HTMLDivElement;
  declare stickyFooterMobileTarget: HTMLDivElement;

  appear(entry) {
    if (entry.isIntersecting) {
      this.stickyFooterTarget.classList.add('is-static');
      this.stickyFooterMobileTarget.classList.add('is-static');
    }
  }

  disappear(entry) {
    if (!entry.isIntersecting) {
      this.stickyFooterTarget.classList.remove('is-static');
      this.stickyFooterMobileTarget.classList.remove('is-static');
    }
  }
}
